import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";

const SlideShow = (props) => {
  const { height, width } = useWindowDimensions();
  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
  };
  return (
    <Carousel {...settings}>
      <Wrap>
        <div
          style={{
            width: width > 768 ? "62%" : "100%",
            marginLeft: width > 768 ? "290px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14 text-xl">
            Get top quality personalized fresher job in real time
          </h3>
          <div className="banner right-0 slideshow_banner">
            <img
              className=""
              src="/jobslider/Job1.jpg"
              alt=""
              style={{
                height: width > 768 ? "100%" : "100%",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap>
        <div
          style={{
            width: width > 768 ? "62%" : "100%",
            marginLeft: width > 768 ? "290px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-xl lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14">
            At every job you should either learn or earn.
          </h3>
          <div className="banner slideshow_banner">
            <img
              src="/jobslider/Job2.jpeg"
              alt=""
              style={{
                height: width > 768 ? "100%" : "100%",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap>
        <div
          style={{
            width: width > 768 ? "62%" : "100%",
            marginLeft: width > 768 ? "290px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-xl lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14">
            Job selection must be based on your skillset, passion & interest.
          </h3>
          <div className="banner slideshow_banner">
            <img
              src="/jobslider/Job5.jpg"
              alt=""
              style={{
                height: width > 768 ? "100%" : "100%",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
      <Wrap>
        <div
          style={{
            width: width > 768 ? "62%" : "100%",
            marginLeft: width > 768 ? "290px" : "1px",
          }}
          className="flex flex-col bg-white lg:flex-row m-10 lg:m-20 h-auto lg:h-[200px] items-center justify-between overflow-hidden rounded-xl"
        >
          <h3 className="text-xl lg:text-2xl p-10 lg:px-20 flex items-center lg:leading-14">
            Select a Job wisely viz. Industry, Company, Growth, etc.
          </h3>
          <div className="banner slideshow_banner">
            <img
              src="/jobslider/Job6.jpg"
              alt=""
              style={{
                height: width > 768 ? "100%" : "100%",
                width: width > 768 ? "100%" : "100%",
              }}
            />
          </div>
        </div>
      </Wrap>
    </Carousel>
  );
};

const Carousel = styled(Slider)`
  margin-top: 20px;
  & > button {
    opacity: 0;
    height: 20%;
    width: 1vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 7px;
      color: rgba(47, 126, 7, 0.832);
    }
  }
  li.slick-active button:before {
    ${"" /* color: '#258480'; */}
  }
  .slick-list {
    overflow: hidden;
  }
  .slick-prev {
    display: none;
  }
  .slick-next {
    display: none;
  }
`;
const Wrap = styled.div``;

export default SlideShow;
